import type { TFunction } from 'i18next';

import type { AppNotification, NotificationWorkflowId } from '../types/notifications.types';

export type NotificationToastSeverity = 'success' | 'error' | 'info';

const toastSeverityByWorkflowId: Partial<
  Record<NotificationWorkflowId, NotificationToastSeverity>
> = {
  'incoming-transfer-completed': 'success',
  'outgoing-transfer-completed': 'success',
  'exchange-transfer-completed': 'success',
  'outgoing-transfer-failed': 'error',
  'exchange-transfer-failed': 'error',
};

const toWorkflowTranslationKey = (workflowId: NotificationWorkflowId): string =>
  workflowId.replace(/-/g, '_');

const getWorkflowTitleTranslationKey = (workflowId: NotificationWorkflowId): string =>
  `nav.notifications_workflows.${toWorkflowTranslationKey(workflowId)}.title`;

export const getNotificationTitle = (notification: AppNotification, t: TFunction): string => {
  const subject = notification.subject?.trim();

  return subject || t(getWorkflowTitleTranslationKey(notification.workflowId));
};

export const getNotificationDescription = (notification: AppNotification): string =>
  notification.body;

export const getNotificationToastSeverity = (
  notification: AppNotification,
): NotificationToastSeverity => toastSeverityByWorkflowId[notification.workflowId] ?? 'info';
